module.exports = __webpack_public_path__ + "img/home_play_pre.c4657274.png";